import { isAxiosError } from 'axios';
import { cn } from '@/lib/cn';

type Props = {
  error: unknown;
  label: string;
};

export function CalendarErrorBanner({ error, label }: Props) {
  if (!error) return null;
  const status = isAxiosError(error) ? error.response?.status : null;
  const message =
    isAxiosError(error) && error.response?.data && typeof error.response.data === 'object'
      ? String((error.response.data as { message?: string }).message ?? error.message)
      : error instanceof Error
        ? error.message
        : String(error);

  const isAuth = status === 401;

  return (
    <div
      className={cn(
        'mb-4 flex items-start gap-3 rounded-2xl border px-4 py-3 text-sm',
        isAuth
          ? 'border-red-100 bg-red-50 text-red-950 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-100'
          : 'border-slate-100 bg-white text-[#0f172b] dark:border-white/5 dark:bg-card dark:text-slate-100'
      )}
      role="alert"
    >
      <span
        aria-hidden="true"
        className={cn(
          'mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full',
          isAuth ? 'bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-300' : 'bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400'
        )}
      >
        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        </svg>
      </span>
      <div className="min-w-0">
        <p className="font-semibold">{isAuth ? 'Unauthorized' : label}</p>
        <p className="mt-0.5 text-slate-500 dark:text-slate-400">{message}</p>
      </div>
    </div>
  );
}
